export default __webpack_public_path__ + "static/media/loading.0df1bc38.gif";